import { render, staticRenderFns } from "./ApproveUser.vue?vue&type=template&id=b4e7b896&scoped=true"
import script from "./ApproveUser.vue?vue&type=script&lang=js"
export * from "./ApproveUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e7b896",
  null
  
)

export default component.exports